import { gql } from '@moonpig/web-core-graphql'
import { ADDONS_FIELDS_FRAGMENT } from '../fragments'

export const GetPeopleAlsoViewedGQL = gql`
  ${ADDONS_FIELDS_FRAGMENT}

  query GetPeopleAlsoViewed($productId: String!, $algorithmId: String!) {
    productLookup(productIds: [$productId]) {
      products {
        peopleAlsoViewed: recommendations(algorithmId: $algorithmId) {
          products {
            id
            title
            description
            variants {
              key
              title
              subtitle
              price {
                currencyCode
                centAmount
                fractionDigits
              }
              fullPrice {
                centAmount
                currencyCode
                fractionDigits
              }
              discountedPercentage
              inStock
              minimumQuantity
              sku
              addons(clientUsesDescription: true) {
                ...AddonsFields
              }
              capabilities {
                video
              }
            }
            category {
              id
              name
              slug
              department
            }
            range {
              key
            }
            customisable
            isLandscape
            masterVariant {
              key
              title
              subtitle
              price {
                centAmount
                currencyCode
                fractionDigits
              }
              fullPrice {
                centAmount
                currencyCode
                fractionDigits
              }
              discountedPercentage
              minimumQuantity
              productImages {
                mainImage {
                  medium {
                    jpgUrl
                  }
                }
                images {
                  small {
                    jpgUrl
                  }
                  medium {
                    jpgUrl
                  }
                  large {
                    jpgUrl
                  }
                }
              }
              addons(clientUsesDescription: true) {
                ...AddonsFields
              }
              inStock
              sku
              capabilities {
                video
              }
            }
            rating {
              count
              score
            }
            slug
            isSponsored
            clickRankDocumentCount
          }
        }
      }
    }
  }
`
